/**
 * Service layer — Proposal Requests (Clerk-authed team side).
 * Wraps /api/proposal-requests. Architect-issued requests for the GC to price a change.
 * The GC's priced response arrives through the contractor-portal intake queue and is
 * finalized here via acceptProposalResponse.
 */

async function call(method, body, qs) {
  const token = typeof window.__clerkGetToken === 'function'
    ? await window.__clerkGetToken().catch(() => null)
    : null
  const r = await fetch('/api/proposal-requests' + (qs ? '?' + qs : ''), {
    method,
    headers: method === 'GET'
      ? { Authorization: 'Bearer ' + token }
      : { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
    body: method === 'GET' ? undefined : JSON.stringify(body),
  })
  if (!r.ok) {
    const b = await r.json().catch(() => ({}))
    throw new Error(b.error || 'proposal-requests error: ' + r.status)
  }
  return r.json()
}

export function getContractProposalRequests(contractId) {
  if (!contractId) return Promise.resolve([])
  return call('GET', null, 'contractId=' + encodeURIComponent(contractId)).then(d => d.proposalRequests || [])
}
export function getProposalRequest(prId) {
  return call('GET', null, 'prId=' + encodeURIComponent(prId))
}
export function createProposalRequest(contractId, projectId, fields) {
  return call('POST', { action: 'createProposalRequest', contractId, projectId, fields }).then(d => d.pr)
}
export function updateProposalRequest(prId, fields) {
  return call('POST', { action: 'updateProposalRequest', prId, fields }).then(d => d.ok)
}
export function deleteProposalRequest(prId) {
  return call('POST', { action: 'deleteProposalRequest', prId }).then(d => d.ok)
}
export function acceptProposalResponse(submissionId) {
  return call('POST', { action: 'acceptProposalResponse', submissionId }).then(d => d.ok)
}
/** Clear the NEW highlight on a PR's portal-submitted responses once a team member views it. */
export function markResponsesSeen(prId) {
  return call('POST', { action: 'markResponsesSeen', prId }).then(d => d.ok)
}
